<template>
  <v-data-table
    :items="infoFaixa"
    :headers="headers"
    hide-details
    hide-default-footer
    disable-pagination
    :hide-default-headers="!infoFaixa.length"
    no-data-text="Não há dados para essa composição de filtros"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td>{{ item['NUM_FAIXA_ETARIA'] }}</td>
        <td class="text-right">{{ item['NUM_CLIENTES_CADASTRADOS'] | localeString }}<mf-quick-actions v-if="!isPdf" v-bind="getQuickActionProps(item)" /></td>
        <td v-if="!isPdf" class="text-right">{{ item['PORCENTAGEM'] | abreviation | percent }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { criteriaGroup, personTypeCriteria, ageRangeCriteria, noAgeRangeCriteria } from '@/components/quick-actions/segmentationGroups.js'

export default {
  props: {
    infoFaixa: {
      type: Array,
      default: () => [],
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Faixa',
          align: 'left',
          value: 'NUM_FAIXA_ETARIA',
        },
        {
          text: 'Quantidade',
          align: 'right',
          value: 'NUM_CLIENTES_CADASTRADOS',
        },
        ...(this.isPdf
          ? []
          : [
              {
                text: '%',
                align: 'right',
                value: 'PORCENTAGEM',
              },
            ]),
      ]
    },
  },
  methods: {
    getQuickActionProps(item) {
      const segmentationGroup = item.ageRange.length
        ? (quickActionFiltersCriteria) =>
            criteriaGroup([
              personTypeCriteria('F'),
              ageRangeCriteria(...item.ageRange),
              ...quickActionFiltersCriteria.criteria.segments,
              ...quickActionFiltersCriteria.criteria.loyalty,
              ...quickActionFiltersCriteria.criteria.clientGroups,
            ])
        : (quickActionFiltersCriteria) =>
            criteriaGroup([
              personTypeCriteria('F'),
              noAgeRangeCriteria(),
              ...quickActionFiltersCriteria.criteria.segments,
              ...quickActionFiltersCriteria.criteria.loyalty,
              ...quickActionFiltersCriteria.criteria.clientGroups,
            ])
      return {
        key: item.ageRange.join('-'),
        quickActionGroupId: `age-range-${item.ageRange.join('-')}`,
        shortDescription: `Clientes na faixa etária - ${item.NUM_FAIXA_ETARIA}`,
        longDescription: `Clientes na faixa etária - ${item.NUM_FAIXA_ETARIA}`,
        segmentationGroup,
      }
    },
  },
}
</script>
